export function InterviewQuestionBankSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/interview-question-bank.svg'"></ng-include>`
    }
}